import { Layers } from "@mui/icons-material";
import { Box, Button, List, ListItemButton, ListItemText, SxProps } from "@mui/material";
import Modal from "components/controls/Modal";
import { FunctionComponent } from "react";
import farmSo from "stores/farm";
import { getGrowUnitLayerName, getLayerByNumber } from "stores/growUnit/utils/layer";
import theme from "styles/theme";
import { Layer } from "types/Layer";



interface Props {
    layers: Layer[]
    layerNumber: number
    growUnitId: number
    open: boolean
    onClose: (layer?: Layer) => void
}
const SelectorLayersDialog: FunctionComponent<Props> = ({
    layers = [],
    layerNumber,
    growUnitId,
    open,
    onClose,
}) => {

    // STORE

    // HOOKs

    // HANDLEs
    const handleLayerClick = (layer: Layer) => {
        onClose(layer)
    }

    // RENDER
    const isSelect = (layer: Layer) => layer.layerNumber == layerNumber

    return <Modal
        sx={{ ".MuiDialog-paper": { width: "365px" } }}
        sxBody={{ display: "flex", flexDirection: "column", gap: 1 }}
        icon={<Layers />}
        title={"LAYER POSITION"}
        isOpen={open}
        onClose={() => onClose()}
        actionsRender={<>
            <div style={{ flex: 1 }} />
            <Button
                onClick={() => onClose()}
            >CANCEL</Button>
        </>}
    >


        {layers.length == 0 ? (
            <Box sx={{ alignSelf: "flex-end", fontSize: "14px", opacity: .6 }}>NO LAYERS AVAILABLE</Box>
        ) : (
            <List sx={{ width: "100%", maxHeight: "400px" }} >
                {layers.map((layer, index) => (

                    <ListItemButton key={layer.layerNumber} dense
                        selected={isSelect(layer)}
                        onClick={() => handleLayerClick(layer)}
                    >
                        <ListItemText
                            primary={
                                <Box sx={sxItem}>
                                    <Box sx={sxLayer(isSelect(layer))}>{getNameLayer(growUnitId, layer.layerNumber)}</Box>
                                    <Box sx={sxPhase}>{layer.phase}</Box>
                                </Box>
                            }
                        //secondary={fnSecondaryFromItem?.(layer)}
                        />
                    </ListItemButton>

                ))}
            </List>
        )}

    </Modal>
}

export default SelectorLayersDialog

const sxItem: SxProps = {
    display: "flex",
    gap: "10px",
    alignItems: "baseline",
}
const sxLayer = (select: boolean): SxProps => ({
    fontSize: 14,
    fontWeight: 700,
    p: "1px 6px",
    borderRadius: "5px",
    ...select ? {
        bgcolor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
    } : {
        bgcolor: theme.palette.text.main,
        color: theme.palette.text.negative,
    }
})
const sxPhase: SxProps = {
    fontSize: 12,
    fontWeight: 500,
    textTransform: "uppercase",
}


// i nomi dei layer utilizzati da questo CYCLE
export const getNameLayer = (growUnitId: number, layerNumber: number) => {
    const growUnit = farmSo.getGrowUnit(growUnitId)
    return getGrowUnitLayerName(growUnit, getLayerByNumber(growUnit, layerNumber))
}